
<template>

  <div class="ui segment">

    <!-- <div class="ui top attached menu">

      <div class="ui icon item">
        <i class="large primary home icon" />
      </div>

    </div> -->

    <!-- Website logo -->
    <a href="/">
      <img width="75%" class="ui centered image" src="@/assets/images/7asanat-logo.png" />
    </a>

    <!-- Website description -->
    <h3 class="ui almarai center aligned primary header">
      <div class="content">نهدي لكم هذه الخدمة لإهداء ثواب الأعمال للمؤمنين</div>
    </h3>

    <!-- Social media -->
    <center>
      <a class="ui big english image label" href="https://www.instagram.com/7asanatnet/">

        <img class="ui centered image" src="@/assets/images/instagram-logo.png" />
        <span class="ui almarai text">تابعنا لتصلك آخر الأعمال</span>
        <i class="hand point up outline icon" />

      </a>
    </center>

    <br>

    <!-- Create khatma -->
    <center>
      <a class="ui big english image label" href="/khatmat/create">

        <img class="ui centered image" src="@/assets/images/quran-icon.png" />
        <span class="ui almarai text">قم بإنشاء ختمتك الخاصة</span>
        <i class="edit icon" />

      </a>
    </center>

  </div>

</template>

<script>
export default {

  name: 'Title'

}
</script>

<style lang="scss" scoped>
.label {
  background-color: white !important;
  color: #3c8c45 !important;

  border-radius: 0.6rem !important;
  box-shadow: 0 0 0 0.08em #3c8c45 inset !important;

  height: 2.79rem !important;

  i {
    margin: 0 0 0 0.5em !important;
  }
}
</style>
